import { useContext } from 'react';

import {
  ScreenRecorderContext,
  ScreenRecorderContextType,
} from '../providers/screen-recorder-context';

export const useScreenRecorderContext = (): ScreenRecorderContextType => {
  const context = useContext(ScreenRecorderContext);
  if (!context) {
    throw new Error(
      'useScreenRecorderContext must be used within a ScreenRecorderProvider',
    );
  }
  return context;
};
